var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDizeelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5004,
    height: 940,
    viewBox: "0 0 5004 940",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M749.012 461.008C749.012 615.509 707.082 733.582 623.224 815.294C539.365 897.006 418.676 937.862 261.224 937.862H2V2H288.796C434.307 2 547.416 42.3194 628.054 122.958C708.692 203.596 749.012 316.302 749.012 461.008ZM633.757 464.832C633.757 342.801 603.165 250.825 541.915 188.971C480.664 127.117 389.695 96.123 268.872 96.123H110.747V843.806H243.244C372.99 843.806 470.467 811.939 535.809 748.14C601.152 684.273 633.757 589.882 633.757 464.832Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1363.4 937.862V2H1472.21V937.862H1363.4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2729.89 937.862H2086.6V852.728L2583.31 99.947H2101.96V2H2715.8V87.1332L2219.09 839.243H2729.89V937.862Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3865.95 937.862H3344.28V2H3865.95V98.6723H3453.09V400.161H3840.99V496.161H3453.09V840.519H3865.95V937.862Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5002 937.862H4480.33V2H5002V98.6723H4589.15V400.161H4977.04V496.161H4589.15V840.519H5002V937.862Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M749.012 461.008C749.012 615.509 707.082 733.582 623.224 815.294C539.365 897.006 418.676 937.862 261.224 937.862H2V2H288.796C434.307 2 547.416 42.3194 628.054 122.958C708.692 203.596 749.012 316.302 749.012 461.008ZM633.757 464.832C633.757 342.801 603.165 250.825 541.915 188.971C480.664 127.117 389.695 96.123 268.872 96.123H110.747V843.806H243.244C372.99 843.806 470.467 811.939 535.809 748.14C601.152 684.273 633.757 589.882 633.757 464.832Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1363.4 937.862V2H1472.21V937.862H1363.4Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2729.89 937.862H2086.6V852.728L2583.31 99.947H2101.96V2H2715.8V87.1332L2219.09 839.243H2729.89V937.862Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3865.95 937.862H3344.28V2H3865.95V98.6723H3453.09V400.161H3840.99V496.161H3453.09V840.519H3865.95V937.862Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5002 937.862H4480.33V2H5002V98.6723H4589.15V400.161H4977.04V496.161H4589.15V840.519H5002V937.862Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDizeelogo);
export default __webpack_public_path__ + "static/media/dizee logo.d78c0045ffd43d7bcb199f30e4ca5f7f.svg";
export { ForwardRef as ReactComponent };